/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RebateCodeEntity = {
    id: string;
    organizationId: string;
    code: string;
    protected: boolean;
    name: string;
    type: RebateCodeEntity.type;
    valueInMills: number;
    scope: RebateCodeEntity.scope;
    minimumSpendingInMills: number | null;
    maxUsages: number | null;
    maxUsagesPerCustomer: number | null;
    validFrom: string;
    validUntil: string | null;
    registeredUsersOnly: boolean;
    verifiedPhoneRequired: boolean;
    customerNote: string | null;
    internalNote: string | null;
    canBeCombined: boolean;
    archived: boolean;
    isTemplate: boolean;
    createdAt: string;
    updatedAt: string;
    organizationEligibility: boolean;
};
export namespace RebateCodeEntity {
    export enum type {
        ABSOLUTE = 'ABSOLUTE',
        PERMILLAGE = 'PERMILLAGE',
    }
    export enum scope {
        ORDER = 'ORDER',
        BOOKING = 'BOOKING',
        CHEAPEST_BOOKING = 'CHEAPEST_BOOKING',
        DUPLICATE_BOOKABLE = 'DUPLICATE_BOOKABLE',
    }
}

